import { Position } from '../position/position.js';
import { search_best_move } from '../search/engine.js';

export async function getEngine() {
    // データをフェッチ
    const resPiece = await fetch('./public/data/piece_data.json');
    const pieceDataList = await resPiece.json();
    
    // Positionクラスは辞書形式を期待している前提だが、
    // pythonの rules.py "load_piece_types" はリストを受け取って辞書を作る
    // （rules.tsの実装に依存）

    const resPlace = await fetch('./public/data/initial_placement.json');
    const initialPlacement = await resPlace.json();

    let pos = new Position(pieceDataList, initialPlacement);

    return {
        async getBoardState() {
            return pos.get_board_state();
        },
        async resetBoard() {
            pos = new Position(pieceDataList, initialPlacement);
        },
        async undoMove() {
            pos.undo();
        },
        async calculateMoves(pid: number) {
            // position.ts の MoveResult[]
            const moves = pos.calculate_moves(pid);
            return moves.map((m: any) => m.to_dict ? m.to_dict() : Object.assign({}, m, {type: m.move_type, capturedPath: m.captured_path}));
        },
        async applyMove(params: { pid: number, to_x: number, to_y: number, captured_path?: number[] }) {
            return pos.apply_move(params.pid, params.to_x, params.to_y, params.captured_path || []);
        },
        async applyShishiMove(params: { pid: number, mid_x: number, mid_y: number, to_x: number, to_y: number }) {
            return pos.apply_shishi_move(params.pid, params.mid_x, params.mid_y, params.to_x, params.to_y);
        },
        async applyHonjuuMove(params: { pid: number, to_x: number, to_y: number, visited: any[] }) {
            return pos.apply_honjuu_move(params.pid, params.to_x, params.to_y, params.visited);
        },
        async promotePiece(pid: number) {
            return pos.promote_piece(pid);
        },
        async shishiSecondMoves(params: { pid: number, first_x: number, first_y: number }) {
            const moves = pos.calculate_shishi_second_moves(params.pid, params.first_x, params.first_y);
            return moves.map((m: any) => m.to_dict ? m.to_dict() : Object.assign({}, m, {type: m.move_type, capturedPath: m.captured_path}));
        },
        async honjuuNextMoves(params: { pid: number, direction: number, current_x: number, current_y: number, remaining_steps: number, origin_x: number, origin_y: number, current_distance: number }) {
            const moves = pos.calculate_honjuu_next_moves(
                params.pid, params.direction, params.current_x, params.current_y,
                params.remaining_steps, params.origin_x, params.origin_y, params.current_distance
            );
            return {
                status: 'ok',
                moves: moves.map((m: any) => m.to_dict ? m.to_dict() : Object.assign({}, m, {type: m.move_type, capturedPath: m.captured_path}))
            };
        },
        async aiMove(depth: number, timeLimitMs: number) {
            const result = search_best_move(pos, depth, timeLimitMs / 1000);
            if (!result) return { status: 'error' };

            const m = result.best_move;
            const pid = m[0], to_x = m[1], to_y = m[2], captured_path = m[3], move_type = m[4];

            const xy = pos.get_piece_xy(pid);
            const from_x = xy ? xy[0] : null;
            const from_y = xy ? xy[1] : null;

            const pMoves = pos.calculate_moves(pid);
            const matchedMove = pMoves.find((mov: any) => mov.to_x === to_x && mov.to_y === to_y);
            const pathArr: any[] = [];
            if (matchedMove && matchedMove.extra && matchedMove.extra.mid_pos) {
                pathArr.push(matchedMove.extra.mid_pos);
            }

            let snapshot;
            snapshot = pos.apply_move(pid, to_x, to_y, captured_path);
            
            if (snapshot.can_promote) {
                pos.promote_piece(pid);
            }

            return {
                status: 'ok',
                move: { 
                    pid, 
                    from_x, 
                    from_y, 
                    to_x, 
                    to_y, 
                    path: pathArr
                },
                move_result: snapshot,
                score: result.score,
                depth_completed: result.depth_completed
            };
        }
    };
}
